import { BRAND } from '../brand/brand.data';

export const NAVIGATIONS = {

  // Landing layout
  root: {
    url: '',
    title: 'SR Group – Industrial & Engineering Distribution Experts',
    description: 'SR Group specialises in industrial lubricants, engineering tools, and OEM distribution services with nationwide reach',
    meta: 'SR Group specialises in industrial lubricants, engineering tools, and OEM distribution services with nationwide reach', //redundant
    keywords: [BRAND.name, 'SR Group'],
  },
  notFound: {
    url: 'not-found',
    title: 'Not Found - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'not found'],
  },
  maintenance: {
    url: 'maintenance',
    title: 'Maintenance - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'maintanence'],
  },
  signupSuccess: {
    url: 'signup-success',
    title: 'Sign Up Success - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Sign Up Success'],
  },
  verifyAccount: {
    url: 'verify-account',
    title: 'Verify Account - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Verify Account'],
  },
  cookiePolicy: {
    url: 'cookie-policy',
    title: 'Cookie Policy - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Cookie Policy'],
  },
  privacyPolicy: {
    url: 'privacy-policy',
    title: 'Privacy Policy - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Privacy Policy'],
  },
  terms: {
    url: 'terms',
    title: 'Terms - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Terms and Services'],
  },
  pricing: {
    url: 'pricing',
    title: 'Pricing - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Pricing'],
  },
  product: {
    url: 'product',
    title: 'Product ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Product'],
  },
  warehouse: {
    url: 'sr-logistics',
    title: 'SR Logistics India P Ltd– Warehousing & Transportation',
    description: 'SR Logistics India Pvt Ltd delivers end-to-end warehousing, secure transportation, and integrated supply-chain solutions',
    keywords: [BRAND.name, 'SR Logistics', 'SR Logistics CFA services'],
  },
  alcadeEngineers: {
    url: 'alcade-engineers',
    title: 'Alcade Engineers – Industrial Tools, Lubricants & Solutions',
    description: 'Alcade Engineers offers trusted industrial welding, maintenance and lubrication solutions for all your industrial needs',
    keywords: [BRAND.name, 'Alcade Engineers', 'Alcade Engineers Hyderabad', 'Alcade Engineers Pvt Ltd', 'Alcade Engineers Pvt Ltd Hyderabad'],
  },
  srEngineers: {
    url: 'sr-engineers',
    title: 'SR Engineers - Industrial Lubricants, Cutting Tools',
    description: 'SR Engineers are trusted distributors of carbide cutting tools & Castrol Lubricants based in Hyderabad & servicing pan India',
    keywords: [BRAND.name, 'SR Engineers', 'SR Engineers Hyderabad'],
  },
  about: {
    url: 'about',
    title: 'About SR Group – Industrial & Engineering Solutions, Products & Services',
    description: 'SR Group stands at the forefront of industrial distribution, engineering innovation, and OEM partnerships across India',
    meta: 'SR Group stands at the forefront of industrial distribution, engineering innovation, and OEM partnerships across India', // redundant
    keywords: [BRAND.name, 'About Us'],
  },
  gallery: {
    url: 'gallery',
    title: 'Gallery ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Gallery'],
  },
  signup: {
    url: 'signup',
    title: 'Sign Up - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Sign Up'],
  },
  login: {
    url: 'login',
    title: 'Login - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Login'],
  },
  branding: {
    url: 'branding',
    title: 'Branding - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Branding'],
  },
  blog: {
    url: 'blog',
    title: 'Blog - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Blog'],
  },
  docs: {
    url: 'docs',
    title: 'Docs - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Docs'],
  },
  partners: {
    url: 'partners',
    title: 'Partners - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Partners'],
  },
  customers: {
    url: 'customers',
    title: 'SR Group – Customer Testimonials & Client Feedback',
    description: 'See what clients say about SR Group’s reliability in industrial distribution, engineering expertise, and service excellence',
    keywords: [BRAND.name, 'Customers'],
  },
  forgetPassword: {
    url: 'forget-password',
    title: 'Forget Password - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Forget Password'],
  },
  resetPassword: {
    url: 'reset-password',
    title: 'Reset Password - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Reset Password'],
  },
  contactUs: {
    url: 'contact-us',
    title: 'Contact SR Group – Industrial & Engineering Support',
    description: 'Get in touch with SR Group for industrial distribution, engineering solutions, and OEM partnership inquiries across India',
    meta: 'Get in touch with SR Group for industrial distribution, engineering solutions, and OEM partnership inquiries across India', //redundant
    keywords: [BRAND.name, 'Contact Us'],
  },
  status: {
    url: 'status',
    title: 'Status - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Status'],
  },
  sitemap: {
    url: 'sitemap',
    title: 'Sitemap - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Sitemap'],
  },
  u: {
    url: 'u',
    title: 'User - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'User'],
  },
  authServerTemplate: {
    url: 'auth-server-template',
    title: 'Auth Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Auth Server Template'],
  },
  paymentServerTemplate: {
    url: 'payment-server-template',
    title: 'Payment Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Payment Server Template'],
  },
  fileStorageServerTemplate: {
    url: 'file-storage-server-template',
    title: 'File Storage Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'File Storage Server Template'],
  },
  mailServerTemplate: {
    url: 'mail-server-template',
    title: 'Mail Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Mail Server Template'],
  },
  analyticsServerTemplate: {
    url: 'analytics-server-template',
    title: 'Analytics Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Analytics Server Template'],
  },
  smsServerTemplate: {
    url: 'sms-server-template',
    title: 'SMS Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'SMS Server Template'],
  },
  businessLogicServerTemplate: {
    url: 'business-logic-server-template',
    title: 'Business Logic Server Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Business Logic Server Template'],
  },
  companyProfileUITemplate: {
    url: 'sr-group',
    title: 'Company Profile UI Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Company Profile UI Template'],
  },
  webUITemplate: {
    url: 'web-ui-template',
    title: 'Web UI Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Web UI Template'],
  },
  mobileUITemplate: {
    url: 'mobile-ui-template',
    title: 'Mobile UI Template - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Mobile UI Template'],
  },
  serverGenerator: {
    url: 'server-generator',
    title: 'Server Generator - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Server Generator'],
  },
  uiGenerator: {
    url: 'app-generator',
    title: 'UI Generator - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'UI Generator'],
  },
  orchestrationServer: {
    url: 'orchestration-server',
    title: 'Orchestration Server - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Orchestration Server'],
  },
  softwareConsultancy: {
    url: 'software-consultancy',
    title: 'Software Consultancy - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Software Consultancy'],
  },
  softwareIntegration: {
    url: 'software-integration',
    title: 'Software Integration - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Software Integration'],
  },
  qualityAssurance: {
    url: 'quality-assurance',
    title: 'Quality Assurance - ' + BRAND.name,
    description: '',
    keywords: [BRAND.name, 'Quality Assurance'],
  },

  // SplashLayout
  callback: {
    url: 'callback',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  dribbble: {
    url: 'dribbble',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  facebook: {
    url: 'facebook',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  github: {
    url: 'github',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  google: {
    url: 'google',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  linkedin: {
    url: 'linkedin',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  reddit: {
    url: 'reddit',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  twitch: {
    url: 'twitch',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  twitter: {
    url: 'twitter',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  stripe: {
    url: 'stripe',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  coinbase: {
    url: 'coinbase',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  paypal: {
    url: 'paypal',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  external: {
    url: 'external',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },

  // Dashboard Layout
  dashboard: {
    url: 'dashboard',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  myProfile: {
    url: 'my-profile',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  createEvent: {
    url: 'create-event',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  learn: {
    url: 'learn',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  event: {
    url: 'event',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  privacy: {
    url: 'privacy',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  user: {
    url: 'user',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },

  // Settings Layout
  settings: {
    url: 'settings',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  editTheme: {
    url: 'edit-theme',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },

  // Localization
  english: {
    url: 'en',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  },
  french: {
    url: 'fr',
    title: BRAND.name,
    description: '',
    keywords: [BRAND.name, 'software business',],
  }
};

export const URLS = {
  // Landing layout
  root: '/',
  notFound: '/' + NAVIGATIONS.notFound.url,
  maintenance: '/' + NAVIGATIONS.maintenance.url,
  signupSuccess: '/' + NAVIGATIONS.signupSuccess.url,
  verifyAccount: '/' + NAVIGATIONS.verifyAccount.url,
  cookiePolicy: '/' + NAVIGATIONS.cookiePolicy.url,
  privacyPolicy: '/' + NAVIGATIONS.privacyPolicy.url,
  terms: '/' + NAVIGATIONS.terms.url,
  pricing: '/' + NAVIGATIONS.pricing.url,
  product: '/' + NAVIGATIONS.product.url,
  warehouse: '/' + NAVIGATIONS.warehouse.url,
  alcadeEngineers: '/' + NAVIGATIONS.alcadeEngineers.url,
  srEngineers: '/' + NAVIGATIONS.srEngineers.url,
  about: '/' + NAVIGATIONS.about.url,
  gallery: '/' + NAVIGATIONS.gallery.url,
  signup: '/' + NAVIGATIONS.signup.url,
  login: '/' + NAVIGATIONS.login.url,
  branding: '/' + NAVIGATIONS.branding.url,
  blog: '/' + NAVIGATIONS.blog.url,
  docs: '/' + NAVIGATIONS.docs.url,
  partners: '/' + NAVIGATIONS.partners.url,
  customers: '/' + NAVIGATIONS.customers.url,
  forgetPassword: '/' + NAVIGATIONS.forgetPassword.url,
  resetPassword: '/' + NAVIGATIONS.resetPassword.url,
  contactUs: '/' + NAVIGATIONS.contactUs.url,
  status: '/' + NAVIGATIONS.status.url,
  sitemap: '/' + NAVIGATIONS.sitemap.url,
  u: '/' + NAVIGATIONS.u.url,

  // SplashLayout
  callback: {
    root: '/' + NAVIGATIONS.callback.url,
    dribbble: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.dribbble.url,
    facebook: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.facebook.url,
    github: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.github.url,
    google: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.google.url,
    linkedin: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.linkedin.url,
    reddit: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.reddit.url,
    stripe: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.stripe.url,
    twitch: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.twitch.url,
    twitter: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.twitter.url,
  },
  external: '/' + NAVIGATIONS.external.url,

  // Dashboard Layout
  dashboard: {
    root: '/' + NAVIGATIONS.dashboard.url,
    myProfile:
      '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.myProfile.url,
    contribute: '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.event.url,
    learn: '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.learn.url,
    event: '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.createEvent.url,
    privacy: '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.privacy.url,
  },
  user: {
    root: '/' + NAVIGATIONS.user.url,
  },

  // Settings Layout
  settings: {
    editTheme: '/' + NAVIGATIONS.settings.url + '/' + NAVIGATIONS.editTheme.url,
  },

  // Languages
  languages: {
    english: '/' + NAVIGATIONS.english.url,
    french: '/' + NAVIGATIONS.french.url
  }
};
